<template>
    <g class="label-group"
       :class="labelClass()"
    >

        <circle class="label-drag-circle"
                :cx="labelPositionX()"
                :cy="labelPositionY()"
                :r="labelRayon()"
        />

        <line
                v-if="hasPointer"
                :x1="labelPositionX()"
                :y1="labelPositionY()"
                :x2="labelPositionPointerX()"
                :y2="labelPositionPointerY()"
        />
        <image :xlink:href="label.getImage()" v-if="label.getImage()"
               :x="labelPositionX() - labelRayon()"
               :y="labelPositionY() - labelRayon()"
               :width="labelRayon() * 2"
               :height="labelRayon() * 2"
               ref="label-markers-image"
        />

        <circle class="label-markers"
                :cx="labelPositionX()"
                :cy="labelPositionY()"
                :r="labelRayon()"
                @mouseenter="$emit('hover')"
                @mouseleave="stopDragDelay"
                @mousedown="startDrag($event)"
                @mouseup="stopDrag()"
                @click="$emit('select')"
                @dblclick.stop="$emit('edit')"
                ref="label-markers"
                :style="!label.getImage()?'fill:rgba(255,255,255,0.5)':''"
        />

        <circle
                class="label-markers-pointer"
                v-if="hasPointer && selected"
                :cx="labelPositionPointerX()"
                :cy="labelPositionPointerY()"
                r="8"
                :class="{'drag':dragPointer}"
                @mousedown="startDragPointer($event)"
                @mouseup="stopDragPointer()"
                ref="label-markers-pointer"
        />

    </g>
</template>

<script>
    import Tools from "../../class/tools";
    import {label} from "@/class/label";
    import events from "@/events/events";

    export default {
        name: "Markers_Pointer",
        props: {
            label: {type:Object,default:() => new label()},
            imageData: {type: Object},
            selected: {type: Boolean},
            hovered: {type: Boolean}
        },
        data() {
            return {
                start: false,
                drag: false,
                dragMove: false,
                dragPointer: false,
                dragOffset: {
                    x: 0,
                    y: 0
                },
            }
        },
        methods: {
            startDrag($event) {

                this.start = true;
                this.dragPointer = false;
                this.dragOffset.x = $event.pageX - (this.$refs["label-markers"].getBoundingClientRect().left + this.labelRayon());
                this.dragOffset.y = $event.pageY - (this.$refs["label-markers"].getBoundingClientRect().top + this.labelRayon());

                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;
                        this.$emit('select');
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            stopDrag() {
                this.start = false;
                
                if(this.dragMove) {
                    this.label.save();
                }
                
                this.drag = false;
                this.dragMove = false;
                this.dragPointer = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
            },
            stopDragDelay() {
                if (this.start && !this.drag) {
                    this.start = false;
                    this.drag = false;
                }
                if (!this.drag) {
                    this.$emit('unhover')
                }
            },
            startDragPointer($event) {
                this.dragOffset.x = $event.pageX - (this.$refs["label-markers-pointer"].getBoundingClientRect().left + 7);
                this.dragOffset.y = $event.pageY - (this.$refs["label-markers-pointer"].getBoundingClientRect().top + 7);
                this.dragPointer = true;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragPointer)
            },
            stopDragPointer() {
                this.dragPointer = false;
                this.$emit('undrag');
    
                this.label.save();
                events.$off("body:click:mouse:up",this.stopDragPointer)
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if (this.start) {
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }

                return classe
            },
            labelPositionX() {
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY() {
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            labelRayon(){
                let diameter = parseFloat(this.label.diameter);
                diameter *= this.imageData.ratioX;
                diameter /= this.imageData.zoom;
                return diameter / 2;
            },
            labelPositionPointerX() {
                let x = parseFloat(this.label.pointer_x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionPointerY() {
                let y = parseFloat(this.label.pointer_y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
        },
        computed: {
            hasPointer() {
                return (this.label.pointer_x_coord != 0 && this.label.pointer_x_coord != null) && (this.label.pointer_y_coord != 0 && this.label.pointer_y_coord != null);
            }
        },
        watch: {
            '$store.state.mouse.position'(value) {

                let label = this.label;

                // drag text
                if (this.drag) {
                    label.x_coord = Tools.format(value.x - this.dragOffset.x,-100, this.imageData.width + 100,this.imageData.ratioX);
                    label.y_coord = Tools.format(value.y - this.dragOffset.y,-1000, this.imageData.height + 1000,this.imageData.ratioY);
    
                    if(this.hasPointer){
                        if(label.pointer_x_coord > label.x_coord - 10 && label.pointer_x_coord < Number(label.x_coord) + 10){
                            label.x_coord = label.pointer_x_coord
                        }
                        if(label.pointer_y_coord > label.y_coord - 10 && label.pointer_y_coord < Number(label.y_coord) + 10){
                            label.y_coord = label.pointer_y_coord
                        }
                    }
                    this.dragMove = true
                }

                // drag pointer
                if (this.dragPointer) {
                    label.pointer_x_coord = Tools.format(value.x - this.dragOffset.x,1, this.imageData.width,this.imageData.ratioX);
                    label.pointer_y_coord = Tools.format(value.y - this.dragOffset.y,1, this.imageData.height,this.imageData.ratioY);
 
                    if(label.pointer_x_coord > label.x_coord - 10 && label.pointer_x_coord < Number(label.x_coord) + 10){
                        label.pointer_x_coord = label.x_coord
                    }
                    if(label.pointer_y_coord > label.y_coord - 10 && label.pointer_y_coord < Number(label.y_coord) + 10){
                        label.pointer_y_coord = label.y_coord
                    }
                }

            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
        },
    }
</script>